import StyledLink from '../StyledLink'
import {
  ADD,
  CUSTOM_SCRIPT,
  SYSTEM
} from '../routes'
import type { Props } from '../types'

const LinkToAddCustomScript = ({
  children,
  isHyperlink
}: Props) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={'/' + SYSTEM + '/' + CUSTOM_SCRIPT + '/' + ADD}
  >
    {children}
  </StyledLink>

export default LinkToAddCustomScript
